// ----------------------------------------------------------------------------
// Component: Page Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import Swiper from 'swiper';
import { Pagination, A11y, Keyboard, EffectFade, Autoplay } from 'swiper/modules';
import 'snippets/card/card';
import 'snippets/icon/icon';
import 'snippets/background-media/background-media';
import 'snippets/video-player/video-block'; //if using page-hero--video

import './page-hero--search.js';

// Styles
import './_page-hero.scss';
import './_page-hero--content-layout.scss';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';

// -------------------------------------
// Variables
// -------------------------------------
var CAROUSEL_SELECTOR = '.carousel--homepage-hero';
var CAROUSEL_CLASS = 'carousel--homepage-hero';
var CAROUSEL_SECTION_SELECTOR = '.homepage-hero';
var CAROUSEL_SECTION_CLASS = 'homepage-hero';
var CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';

// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach((element, index) => {
  var _element$querySelecto;
  // Generate unique class for each collection list slider
  element.querySelector(CAROUSEL_SELECTOR).classList.add("".concat(CAROUSEL_CLASS, "-").concat(index));
  (_element$querySelecto = element.querySelector(CAROUSEL_PAGINATION_SELECTOR)) === null || _element$querySelecto === void 0 || _element$querySelecto.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-pagination-").concat(index));
  var swiper = new Swiper(".".concat(CAROUSEL_CLASS, "-").concat(index), {
    // Optional parameters
    modules: [Pagination, A11y, Keyboard, EffectFade, Autoplay],
    slidesPerView: 1,
    spaceBetween: 0,
    observer: true,
    observeParents: true,
    a11y: {
      slideRole: null
    },
    watchOverflow: true,
    loop: true,
    effect: "fade",
    speed: 1000,
    keyboard: true,
    watchSlidesProgress: true,
    pagination: {
      el: ".".concat(CAROUSEL_SECTION_CLASS, "-pagination-").concat(index),
      clickable: true,
      renderBullet: function renderBullet(bulletIndex, className) {
        return "<span type=\"button\" tabindex=\"0\" class=\"".concat(className, "\"></span>");
      }
    },
    hashNavigation: {
      watchState: true
    },
    autoplay: {
      delay: 7000,
      disableOnInteraction: false
    },
    on: {
      slideChange() {
        var bullets = element.querySelectorAll("".concat(CAROUSEL_SECTION_SELECTOR, "-pagination-").concat(index, " .swiper-pagination-bullet"));
        bullets.forEach((bullet, bulletIndex) => {
          if (bulletIndex === swiper.activeIndex) {
            bullet.setAttribute('aria-current', 'true');
          } else {
            bullet.removeAttribute('aria-current');
          }
        });
      },
      afterInit: function afterInit(swiper) {
        // Play/Pause control button
        var controlBtn = element.querySelector('.testimonial__control');
        var paginationContainer = element.querySelector("".concat(CAROUSEL_SELECTOR, "-").concat(index) + ' .pagination__container');
        var activeBullet = element.querySelector('.swiper-pagination-bullet-active');
        var video = element.querySelector('.video-block__video');
        controlBtn === null || controlBtn === void 0 || controlBtn.addEventListener('click', function () {
          if (this.getAttribute('aria-pressed') === 'false') {
            video.pause();
            swiper.autoplay.stop();
            this.querySelector('.screen-reader-text').textContent = 'Play';
            paginationContainer.classList.add('play');
            paginationContainer.classList.remove('pause');
            this.setAttribute('aria-pressed', 'true');
            activeBullet.style.animationPlayState = 'paused';
          } else {
            video.play();
            swiper.autoplay.start();
            this.querySelector('.screen-reader-text').textContent = 'Pause';
            paginationContainer.classList.add('pause');
            paginationContainer.classList.remove('play');
            this.setAttribute('aria-pressed', 'false');
          }
        });
        var paginationBullets = element.querySelectorAll("".concat(CAROUSEL_SECTION_SELECTOR, "-pagination-").concat(index, " .swiper-pagination-bullet"));
        paginationBullets.forEach((bullet, bulletIndex) => {
          // Move to corresponding slide when Enter is pressed into pagination bullet
          bullet.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault(); // prevent scrolling for space
              swiper.slideTo(bulletIndex);
            }
          });

          // Move to corresponding slide when bullet is clicked
          if (swiper.params.loop) {
            bullet.addEventListener('click', e => {
              var bulletEl = e.target.closest('.swiper-pagination-bullet');
              if (!bulletEl) {
                return;
              }
              e.preventDefault();
              swiper.slideTo(bulletIndex);
            });
          }
        });
      }
    }
  });
});